import React, { FormEvent, Ref, useState } from 'react';
import styled from 'styled-components';

import { Container, ErrorContainer, Input, InputContainer, Label } from '../forms/Input';

interface Props {
  disabled?: boolean;
  startTime: string;
  endTime: string;
  onStartChange: (startTime: string) => void;
  onEndChange: (endTime: string) => void;
  onInvalid?: (e: FormEvent) => void;
  error?: string;
  errorRef?: Ref<HTMLDivElement>;
  required?: boolean;
}

const TimeFormInput = ({
  disabled,
  startTime,
  endTime,
  onStartChange,
  onEndChange,
  onInvalid,
  error,
  errorRef,
  required,
}: Props) => {
  const [invalid, setInvalid] = useState(false);

  const myOnStartChange = (value: string) => {
    setInvalid(false);
    onStartChange(value);
  }

  const onInputInvalid = (e: FormEvent) => {
    e.preventDefault();
    setInvalid(true);
    if (onInvalid) {
      onInvalid(e);
    }
  }

  return <Container $growing={true} ref={errorRef}>
    <TwoColumnContainer>
      <InputContainer $filled={true} $fixedHeight={true}>
        <TimeInput
          value={startTime}
          onChange={(e) => myOnStartChange(e.currentTarget.value)}
          onInvalid={onInputInvalid}
          disabled={disabled}
          type="time"
          required={required}
        />
        <Label>From?</Label>
      </InputContainer>
      <InputContainer $filled={true} $fixedHeight={true}>
        <TimeInput
          value={endTime}
          onChange={(e) => onEndChange(e.currentTarget.value)}
          disabled={disabled}
          type="time"
        />
        <Label>To?</Label>
      </InputContainer>
    </TwoColumnContainer>
    { invalid ? <ErrorContainer>This is a required field</ErrorContainer> : null }
    { error ? <ErrorContainer>{error}</ErrorContainer> : null }
  </Container>;
};

const LabelContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const TimeLabel = styled(Label)`
  flex-grow: 1;
  flex-basis: 0;
`;

const TimeInputContainer = styled(InputContainer)`
  display: flex;
  gap: 10px;
`;

const StartTimeContainer = styled.div`
  flex-grow: 1;
  flex-basis: 0;
  display: flex;
  gap: 5px;
`;

const TimeInput = styled(Input)`
  flex-grow: 1;
  flex-basis: 0;
  color: var(--shine-text-color);
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  padding: 0 16px 0 16px;
  display: flex;
  margin-top: 20px;
  
  &::-webkit-calendar-picker-indicator {
    background: none;
    display: none;
  }
`;

const TwoColumnContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
`

export default TimeFormInput;
